@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object CancelRideEndpoint : EndPoint<CancelRideEndpoint.Request, CancelRideEndpoint.Response>() {
    class Request(
        val rideId: KmmLong,
        val reason: String?,
    )

    class Response()
}